import { UrbanBathroomContainer } from '../../containers/advancedFilters/UrbanBathroomContainer';
import { IFilter } from '../../types/filters';

export const urbanBathroom: IFilter = {
  component: UrbanBathroomContainer,
};
